module.exports = __webpack_public_path__ + "static/img/gptnew2.f25b4ef5.png";